var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import Modal from './components/templates/Modal/Modal';
import { useQueryStringParams } from './businessLogics/hooks';
import { useUserInfo } from './businessLogics/apis';
import MarketingAgreementEvent from './components/organisms/MarketingAgreementEvent';
import { getCookie } from './businessLogics/_utils';
var EventMarketingAgreement = function (_a) {
    var _b;
    var CPLogger = _a.CPLogger;
    var query = useQueryStringParams();
    var _c = useState(true), isShow = _c[0], setIsShow = _c[1];
    var userInfo = useUserInfo();
    var seenMarketingAgreement = getCookie('seenMarketingAgreement');
    useEffect(function () {
        setIsShow(query.get('required_marketing') === 'true');
    }, [query.get('required_marketing')]);
    return (_jsx(_Fragment, { children: userInfo.isSuccess &&
            isShow &&
            !seenMarketingAgreement &&
            !((_b = userInfo.data) === null || _b === void 0 ? void 0 : _b.user.marketing(_jsx(Modal, __assign({ isShow: isShow, setIsShow: setIsShow, isFitContent: true, CPLogger: CPLogger }, { children: _jsx(MarketingAgreementEvent, { isShow: isShow, setIsShow: setIsShow, userInfo: userInfo, CPLogger: CPLogger }) })))) }));
};
export default EventMarketingAgreement;
//# sourceMappingURL=MarketingAgreement.js.map